import React, { ReactNode } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { useUser } from '../../hooks/useUser'
import { useRmnBrand } from './RmnBrandContext'
import { isInternal } from '../../utils'
import { portalBasePath } from '../../utils/portalPath'

interface Props {
  children: ReactNode
}

// Client-side UX gate for the brand-portal workspace pages: logged-out
// users go to the branded login (preserving the redirect target); users with
// no membership on the resolved brand (internal staff excepted — they open
// any brand's workspace) get 403. Real enforcement happens on the API via
// rmnControl.
export function RmnAuthGuard({ children }: Props) {
  const { user, role } = useUser()
  const { brand, loading } = useRmnBrand()
  const { brandSlug } = useParams()
  const location = useLocation()

  if (loading) return null

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`${portalBasePath(String(brandSlug))}/login?redirect=${redirect}`} replace />
  }

  if (!isInternal(String(role))) {
    // Direct membership on the resolved brand only — supplier-brand users
    // (associated to an RMN network) are deliberately kept out, matching
    // rmnControl on the API.
    const memberBrands: any[] = (user as any)?.brand || []
    const isMemberOfRmn = memberBrands.some((b) => b?.id === brand?.id)
    if (!isMemberOfRmn) {
      return <Navigate to="/403" replace />
    }
  }

  return <>{children}</>
}
